import { render } from "./OpeningTimes.vue?vue&type=template&id=a5f59c00&scoped=true"
import script from "./OpeningTimes.vue?vue&type=script&lang=js"
export * from "./OpeningTimes.vue?vue&type=script&lang=js"

import "./OpeningTimes.vue?vue&type=style&index=0&id=a5f59c00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5f59c00"]])

export default __exports__